export default (player) => {
  const menu = jQuery(player?.elements?.container).find(
    ".plyr__menu__container"
  );
  var ro = new ResizeObserver((entries) => {
    for (let entry of entries) {
      const cr = entry.contentRect;

      jQuery(entry.target)
        .find(".plyr__menu__container")
        .css({ maxHeight: `${cr.height - 48}px` });
    }
  });
  ro.observe(player?.elements?.container);

  // this resets style on play for some reason
  player.on("playing", () => {
    const cr = player?.elements?.container.getBoundingClientRect();
    jQuery(player?.elements?.container)
      .find(".plyr__menu__container")
      .css({ maxHeight: `${cr.height - 48}px` });
  });
};
